// src/helpers/create-audio.ts
// Creates an HTMLAudioElement that is attached to the DOM.
// Android WebView can silently refuse to play audio elements
// that are not in the document tree.

export function createAudio(): HTMLAudioElement {
  const audio = document.createElement('audio');
  audio.style.position = 'absolute';
  audio.style.width = '0';
  audio.style.height = '0';
  audio.style.opacity = '0';
  audio.style.pointerEvents = 'none';
  audio.preload = 'auto';
  document.body.appendChild(audio);
  return audio;
}

export function destroyAudio(audio: HTMLAudioElement): void {
  try {
    audio.pause();
    audio.src = '';
    audio.load();
  } catch {}
  try {
    audio.remove();
  } catch {}
}
